<template>
    <div class="tours">
        <div class="top">
            <!-- <img src="../../assets/imgs/travel-diary-bg.png" alt=""> -->
            <div class="title">Travel Diary</div>
            <!-- 没用 -->
        </div>
        <div class="breadcrumb">
            <el-breadcrumb :separator-icon="ArrowRight">
                <el-breadcrumb-item :to="{ path: '/diary' }">Travel Diary</el-breadcrumb-item>
                <el-breadcrumb-item>2025 (純玩)廈門武夷山鼓浪嶼泉州6天</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="staff">
            <div class="title">2025 (純玩)廈門武夷山鼓浪嶼泉州6天</div>
            <div class="staff-con">

                <div class="con" v-html="editorHtml"></div>
            </div>
            <div class="staff-con">
                <div class="form">
                    <div class="form-title">Reviews</div>
                    <el-form ref="ruleFormRef" label-position="top" :model="ruleForm" :rules="rules"
                        class="demo-ruleForm" :size="formSize" status-icon>
                        <el-form-item label="rating" prop="name">
                            <el-rate v-model="ruleForm.value" :max="5" size="large" />
                        </el-form-item>
                        <el-form-item label="review" prop="name">
                            <el-input v-model="ruleForm.name" placeholder="please enter your review" />
                        </el-form-item>
                        <el-form-item label="name" prop="name">
                            <el-input v-model="ruleForm.name" placeholder="please enter your name" />
                        </el-form-item>
                        <el-form-item label="email" prop="name">
                            <el-input v-model="ruleForm.name" placeholder="please enter your email" />
                        </el-form-item>
                        <el-form-item>
                            <el-checkbox v-model="ruleForm.checked"
                                label="Save my name, email, and website in this browser for the next time I comment." />
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submitForm(ruleFormRef)">
                                Create
                            </el-button>
                            <el-button @click="resetForm(ruleFormRef)">Reset</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
        <div class="travel-title">Related products</div>
        <div class="travel-lists">
            <div class="list" @click="toDetailFn">
                <div class="img">
                    <img src="https://www.youngtravel.com.au/wp-content/uploads/2025/05/%E5%87%B1%E6%81%A9%E6%96%AF-%E5%86%92%E9%9A%AA%E8%99%9F-20250317-s-1536x867.jpg"
                        alt="">
                </div>
                <div class="title u-line-2">
                    【中文团】凯恩斯3/4日精华游 （可選包含酒店或不包含酒店）Cairns 4 day essence tour (Optional to include hotel or not include
                    hotel)
                </div>
                <div class="btn">Read More</div>
            </div>
            <div class="list" @click="toDetailFn">
                <div class="img">
                    <img src="https://www.youngtravel.com.au/wp-content/uploads/2025/05/%E5%A2%A8%E7%88%BE%E6%9C%AC5%E6%97%A5%E9%81%8A-S-scaled.jpg"
                        alt="">
                </div>
                <div class="title u-line-2">
                    【中文团】墨尔本5日游 Mandarin Tour – Melbourne 5 Days Tour
                </div>
                <div class="btn">Read More</div>
            </div>
            <div class="list" @click="toDetailFn">
                <div class="img">
                    <img src="https://www.youngtravel.com.au/wp-content/uploads/2025/05/2025-%E7%B4%94%E7%8E%A9%E5%8E%A6%E9%97%A8%E6%AD%A6%E5%A4%B7%E5%B1%B1%E9%BC%93%E6%B5%AA%E5%B1%BF%E6%B3%89%E5%B7%9E6%E5%A4%A9AUD_001-1117x1536.jpg"
                        alt="">
                </div>
                <div class="title u-line-2">
                    2025 (純玩)廈門武夷山鼓浪嶼泉州6天
                </div>
                <div class="btn">Read More</div>
            </div>
            <div class="list" @click="toDetailFn">
                <div class="img">
                    <img src="https://www.youngtravel.com.au/wp-content/uploads/2025/05/2025-%E7%B4%94%E7%8E%A9%E6%88%90%E9%83%BD%E4%B8%89%E6%98%9F%E5%A0%86%E7%86%8A%E7%8C%AB%E5%9F%BA%E5%9C%B0-6%E5%A4%A9AUD_001-600x825.jpg"
                        alt="">
                </div>
                <div class="title u-line-2">
                    2025 (純玩)成都三星堆熊猫基地 6天
                </div>
                <div class="btn">Read More</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            editorHtml: ` 
                <div class="_j_content_box">
                    <p class="_j_note_content _j_seqitem" data-seq="1934236043">
                        “<span>台州</span>
                        ”是一座风光优美，文化底蕴丰厚的城市。
                        <span>台州</a>
                        古称海州，因“<span>天台</span>
                        山”得名；<span>台州</span>
                        府城所在地（<span>临海</span>
                        市），拥有“千年<span>台州</span>
                        府，<span>江南</span>
                        真宋城”的美誉；<span>天台</span>
                        山更是佛教<span>天台</span>
                        宗和道教南宗的发源地。<br>
                        市政府所在地（椒江），没有什么旅游景点，景点分布在其周边几十（近百）公里处，需要提前做好攻略。<br>
                    </p>
                    <div data-seq="1934241109" data-index="1" class="article_title _j_anchorcnt _j_seqitem">
                        <h2 class="t9"><span class="_j_anchor">一、序曲：匆匆走过的“台州市”</span></h2>
                    </div>
                    <p class="_j_note_content _j_seqitem" data-seq="1934241159">
                        我们是从
                        <span>奉化</span>
                        乘坐动车来到
                        <span>台州</span>
                        的。提前没有做攻略，是一次随心而行，说走就走的出行，因而也走了一点弯路。<br>
                        <br>
                        椒江区作为
                        <span>台州</span>
                        市的主城区（
                        <span>台州</span>
                        市辖椒江、黄岩、路桥3个区)，是
                        <span>台州</span>
                        市政府的驻地，承担着市级行政管理的核心职能。该区域集中了
                        <span>台州</span>
                        市的主要行政机构，包括市政府办公室、外事办公室等，说好的山海风光在哪里？旅游，难道我们来错了地方！<br>
                    </p>
                    <div data-seq="1935427200" data-index="2" class="article_title _j_anchorcnt _j_seqitem">
                        <h2 class="t9"><span class="_j_anchor">台州“路桥十里长街”</span></h2>
                    </div>
                    <div id="_j_photo_1934242813" data-seq="1934242865" data-pid="1934242813"
                        class="add_pic _j_anchorcnt _j_seqitem" data-poiid="6328137">
                        <img class="" style="height: auto; width: 100%;display: block;margin:10px auto"
                                src="https://img0.baidu.com/it/u=1266812337,729223184&fm=253&fmt=auto&app=138&f=JPEG?w=712&h=500"
                                data-pid="1934242813" alt="">
                        <span class="pic_tag"> 
                                <i class="house"></i>路桥十里长街
                        </span>
                    </div> 
                    <p class="_j_note_content _j_seqitem" data-seq="1934371270">
                        【路桥十里长街】始建于南宋（因五代吴越国王钱镠开凿南官河而兴建），鼎盛于明清，全长超过3公里，由河西街延伸至石曲街，是浙东南著名商埠的见证。<br>
                        <br>
                        因“路即桥、桥即路”得名“路桥”，南宋皇帝赵构曾途经此地留下了典故：南宋初年，赵构（宋高宗）为躲避金兵南逃至浙东，途经
                        <span>台州</span>
                        路桥时，见当地河道纵横、桥梁密布，感叹“路即桥，桥即路”，此地因而得名“路桥”。<br>
                        <br>
                        路桥十里长街依南官河而建，形成水街格局，保留了明清斗式吊楼、青石板路、临水廊道，形成“水街一体”的
                        <span>江南</span>
                        特色。<br>
                        <br>
                        十里长街现存明代福星桥、虹桥等古桥，以及邮亭驿站、东岳庙石狮子、杨晨故居等人文景观。
                    </p>
                    <div class="add_pic _j_anchorcnt _j_seqitem">
                        <img class="" style="height: auto; width: 100%;display: block;margin:10px auto"
                            src="https://ns-strategy.cdn.bcebos.com/ns-strategy/upload/fc_big_pic/part-00202-2394.jpg">
                        <span class="pic_tag">
                                <i class="house"></i>路桥十里长街
                        </span>
                    </div> 
                    <p class="_j_note_content _j_seqitem" data-seq="1934372615">
                        长街入口处一个硕大的“福”字夺人眼球，细看说明文字，这个福字原来大有讲究：这是一款宋韵风格的"福"字，是路桥独有的文化符号，风格简洁素雅。<br>
                        <br>
                        “宋韵福”由莲花的5种形态组成，左边上面是莲花的花笆，下面是莲叶（老叶子），右边最上面是一个莲蓬，中间是一朵莲花，最下面是一片新叶平浮在水面上。<br>
                        从年幼到老，五福在
                        <span>中国</span>
                        古代五口之家是幸福之家的基础。宋韵福，更是谐音"送福"，共情游客美好生活！开心，福到！
                    </p>
                </div>
            `,
            activeName: 'first',
            formSize: 'default',
            ruleForm: {
                name: 'Hello',
                region: '',
                value: 0,
                checked: false,
                count: '',
                date1: '',
                date2: '',
                delivery: false,
                location: '',
                type: [],
                resource: '',
                desc: '',
            },
            rules: {
                name: [
                    { required: true, message: 'Please input Activity name', trigger: 'blur' },
                    { min: 3, max: 5, message: 'Length should be 3 to 5', trigger: 'blur' },
                ],
                region: [
                    {
                        required: true,
                        message: 'Please select Activity zone',
                        trigger: 'change',
                    },
                ],
            }
        }
    },
    methods: {
        handleClick(tab, event) {
            console.log(tab, event)
        },
        submitForm() {
            this.$refs.ruleFormRef.validate((valid, fields) => {
                if (valid) {
                    console.log('submit!')
                } else {
                    console.log('error submit!', fields)
                }
            })
        },
        resetForm() {
            this.$refs.ruleFormRef.resetFields()
        },
        toDetailFn() {
            console.log(1111111)
            this.$router.push('/zh/toursDetail')
        }
    }
}
</script>

<style lang="less" scoped>
.tours {
    padding-bottom: 120px;

    .top {
        width: 100vw;
        height: 650px;
        position: relative;
        overflow: hidden;

        &::after {
            content: '';
            top: 0;
            left: 0;
            position: absolute;
            width: 100%;
            height: 200px;
            background: linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 100%);
            z-index: 1;
        }

        .title {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 80px;
            font-weight: 700;
            color: #fff;
            z-index: 3;
            text-shadow: 3px 3px 5px #002c2d;
            letter-spacing: 2px;
        }

        .subtitle {
            position: absolute;
            top: 60%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 80px;
            font-weight: 700;
            color: #fff;
        }


        img {
            width: 100%;
            object-fit: cover;
            height: 100%;
            transition: .3s all;
        }

        &:hover img {
            transform: scale(1.1);
        }
    }

    .breadcrumb {
        margin: 40px auto;
        max-width: 1200px;
    }

    .staff {
        max-width: 1200px;
        margin: 0 auto;

        .title {
            font-size: 30px;
            font-weight: 700;
            margin: 80px 0;
            text-align: center;
            color: #ec0b29;
        }

        .staff-con {
            display: flex;
            position: relative;

            .form {
                padding: 20px;
                width: 1000px;
                margin: 100px auto 40px;
                border-radius: 10px;
                box-sizing: border-box;
                box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.23), 0 6px 20px 0 rgba(0, 0, 0, 0.22);

            }

            .el-form {
                display: flex;
                flex-wrap: wrap;
            }

            .el-form-item {
                width: calc(50% - 10px);
                margin-right: 20px;
            }

            .el-form-item:nth-of-type(2n) {
                margin-right: 0;
            }

            .el-form-item:nth-last-of-type(1),
            .el-form-item:nth-last-of-type(2) {
                width: 100%;
            }

            .el-form-item:nth-last-of-type(1) {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .form-title {
                margin-bottom: 30px;
                font-size: 20px;
                text-align: center;
            }

            .img {
                width: 300px;
                flex-shrink: 0;
                margin-right: 20px;
            }

            .el-image {
                border: 1px solid #ec0b29;
                border-radius: 6px;
            }

            .con {
                flex: 1;
                margin-left: 10px;
            }
        }
    }

    .travel-title {
        text-align: center;
        font-size: 30px;
        font-weight: 700;
        margin: 80px 0;
        color: #222;
        border-top: 1px solid #eee;
        padding-top: 40px;
    }

    .travel-lists {
        max-width: 1200px;
        margin: 80px auto 100px;
        display: flex;
        flex-wrap: wrap;

        .list {
            background-color: #f0f0f0;
            width: calc(25% - 20px);
            margin-right: 25px;
            padding: 5px;
            box-sizing: border-box;
            border-radius: 5px;
            overflow: hidden;
            cursor: pointer;
            margin-bottom: 30px;
            border: 1px solid #ddd;

            &:nth-of-type(4n) {
                margin-right: 0;
            }

            .img {
                width: 100%;
                height: 350px;
                overflow: hidden;
                display: flex;
                align-items: start;
                justify-content: center;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    object-position: center top;
                    transition: .3s all;
                }
            }

            .title {
                font-size: 16px;
                font-weight: 700;
                color: #000;
                padding: 10px;
                box-sizing: border-box;
                height: 60px;
                transition: .3s all;
            }

            .btn {
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: #ec0b29;
                color: #fff;
                font-size: 14px;
                font-weight: 500;
                cursor: pointer;
                width: 100px;
                height: 30px;
                box-sizing: border-box;
                float: right;
                margin-top: 10px;
                border-radius: 4px;
                margin-right: 10px;
                margin-bottom: 6px;
                transition: .3s all;
            }

            &:hover {
                box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.23), 0 6px 20px 0 rgba(0, 0, 0, 0.22);

                .img img {
                    transform: scale(1.1);
                }

                .title {
                    color: #ec0b29;
                }
            }
        }
    }

    .el-pagination {
        margin: 50px auto 120px;
        display: flex;
        justify-self: center;
    }

    :deep(.el-pagination.is-background .el-pager li.is-active) {
        background-color: #ec0b29;
    }

    :deep(.el-pager li:hover) {
        color: #ec0b29;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/en/diaryDetail.vue